import { Routes } from '@angular/router';

import descriptionRouteData from './components/description/route-data';
import overviewRouteData from './components/overview/route-data';
import realizationRouteData from './components/realization/route-data';

export default <Routes>[
  {
    path: '',
    loadComponent: async () => import('./components/layout/layout.component'),
    children: [
      {
        path: '',
        loadComponent: async () => import('./components/overview/overview.component'),
        data: overviewRouteData
      },
      {
        path: 'description',
        loadComponent: async () => import('./components/description/description.component'),
        data: descriptionRouteData
      },
      {
        path: 'realization',
        loadComponent: async () => import('./components/realization/realization.component'),
        data: realizationRouteData
      }
    ]
  }
];
